module.exports = __webpack_public_path__ + "img/e7d66b9.png";